<template>
  <v-flex class="bxp-layout-sidebar" :style="{backgroundImage: 'url(' + backgroundImageUrl + ')'}">
    <div class="bxp-layout-sidebar-content">
      <p class="bxp-sidebar-primary-text">
        <slot name="primary-text">

        </slot>
      </p>
      <p class="bxp-sidebar-secondary-text">
        <slot name="secondary-text">

        </slot>
      </p>
      <p class="bxp-sidebar-sub-text">
        <slot name="sub-text">

        </slot>
      </p>
    </div>
  </v-flex>
</template>

<script>
  export default {
    props: [
      'backgroundImageUrl'
    ]
  }
</script>

<style>
  .bxp-layout-sidebar {
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    min-width: 600px !important;
    width: 30%;
    min-height: 880px;
    flex-grow: 0 !important;
    background-position: center;
    background-size: cover;
    margin-top: 113px;
  }

  .bxp-layout-sidebar-content {
    margin: 0 auto;
    width: 496px;
  }

  .bxp-sidebar-primary-text {
    font-size: 36px;
    line-height: 47px;
    margin-bottom: 40px !important;
  }

  .bxp-sidebar-secondary-text {
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 40px !important;
  }

  .bxp-sidebar-sub-text {
    font-size: 22px;
    line-height: 32px;
    font-style: italic;
  }

  /* Responsive **************/
  @media (max-width: 1032px) {
    .v-toolbar__content {
      height: 78px !important;
      padding: 0 14px;
    }

    .bxp-layout-sidebar {
      display: none;
    }
  }
</style>
